// extracted by mini-css-extract-plugin
export default {"parent":"ehrDetails_parent__OOplD","parentName":"ehrDetails_parentName__h1orM"};